
import React, { useEffect, useState } from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import DruPozComboBox from '../../common/client/components/DruPozComboBox';
import Text from '../../common/client/components/Text';

import CategoryItemComboBox from '../common/CategoryItemComboBox';
import KatuzeComboBox from '../common/KatuzeComboBox';
import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoSearch from './ObjectInfoSearch';
import ToolbarCommandButton from './ToolbarCommandButton';
import ObjectInfoParcely from './ObjectInfoParcely';

const classNames = mergeStyleSets({
    checkbox: {
        paddingTop: 8
    }
});

const SearchParParams = (props) => {

    const [params, setParams] = useState({
        categoryItem: '',
        cisloTel: '',
        druPozKod: '',
        katuzeKod: '',
        parCis: '',
        onlyList: true,
        onlySelected: false
    });

    useEffect(() => {
        if (props.onChangeParams) {
            props.onChangeParams(params);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    const setParamValue = (name, value) => {
        setParams({
            ...params,
            [name]: value
        });
    }

    const handleChangeCategoryItem = (value) => {
        setParamValue('categoryItem', value);
    }

    const handleChangeCisloTel = (event) => {
        setParamValue('cisloTel', event.target.value);
    }

    const handleChangeDruPozKod = (value) => {
        setParamValue('druPozKod', value);
    }

    const handleChangeKatuze = (value) => {
        setParamValue('katuzeKod', value);
    }

    const handleChangeOnlyList = (event, isChecked) => {
        setParamValue('onlyList', isChecked);
    }

    const handleChangeOnlySelected = (event, isChecked) => {
        setParamValue('onlySelected', isChecked);
    }

    const handleChangeParCis = (event) => {
        setParamValue('parCis', event.target.value);
    }

    return (
        <Stack>
            <KatuzeComboBox
                all={true}
                data={props.params.katuze}
                value={params.katuzeKod}
                onChange={handleChangeKatuze}
            />
            <Stack horizontal tokens={{childrenGap: 8}}>
                <TextField
                    label="Parcelní číslo"
                    value={params.parcis}
                    onChange={handleChangeParCis}
                />
                <TextField
                    label="Číslo LV"
                    value={params.cisloTel}
                    onChange={handleChangeCisloTel}
                />
            </Stack>
            <DruPozComboBox
                all={true}
                value={params.druPozKod}
                onChange={handleChangeDruPozKod}
            />
            <CategoryItemComboBox
                all={true}
                data={props.params.categoryItems}
                value={params.categoryItem}
                onChange={handleChangeCategoryItem}
            />
            <Checkbox
                label="Vyhledávat pouze v seznamu parcel"
                checked={params.onlyList}
                onChange={handleChangeOnlyList}
                className={classNames.checkbox}
            />
            <Checkbox
                label="Vyhledávat pouze ve vybraných parcelách"
                checked={params.onlySelected}
                onChange={handleChangeOnlySelected}
                className={classNames.checkbox}
            />
        </Stack>
    );
}

const ObjectInfoSearchParParams = (props) => {

    const handleChangeParams = (params) => {
        if (props.onChangeParams) {
            props.onChangeParams(params);
        }
    }

    const handleSearchClick = () => {
        if (props.onSearchClick) {
            props.onSearchClick();
        }
    }

    return (
        <React.Fragment>
            <ObjectInfoTitle title="VYHLEDÁVÁNÍ PARCEL" />
            {props.params
                ? <React.Fragment>
                    <SearchParParams
                        params={props.params}
                        onChangeParams={handleChangeParams}
                    />
                    <ToolbarCommandButton items={[{
                        text: 'Vyhledat',
                        title: 'Vyhledat parcely podle zadaných parametrů',
                        onClick: handleSearchClick
                    }]}/>
                    {props.loading
                        ? <Text>Vyhledávám parcely...</Text>
                        : null
                    }
                </React.Fragment>
                : <Text>Načítám parametry pro vyhledávání...</Text>
            }
        </React.Fragment>
    );
}

const ObjectInfoSearchParcela = (props) => {

    return (
        <ObjectInfoSearch
            searchType="PAR"
            paramsClass={ObjectInfoSearchParParams}
            resultClass={ObjectInfoParcely}
            resultPropName="parc"
            resultProps={{
                onlyInList: false,
                titleVisible: false
            }}
        />
    );
}

export default ObjectInfoSearchParcela;
